import cardPainterManager from '../../../../../Widgets/DataPainterWidget/Core/CardPainterManager';
import commandEngine from './CommandEngine';
import { CMD_SERVICEOVERVIEW_REGISTRY_KEY, META_TYPE, META_VER } from './serviceOverviewCommandRegisteryType';

/**
 * Registers the /services command with the CommandEngine.
 * /services — opens/refocuses the service overview (single instance, target=services).
 */
export function registerServiceOverviewCommand() {
    commandEngine.register('/services', {
        hint: 'open service overview (state + memory per instance)',
        params: [],
        handler: () => {
            cardPainterManager.openCard(CMD_SERVICEOVERVIEW_REGISTRY_KEY, { type: META_TYPE, ver: META_VER, target: 'services' }, {});
        },
    });
}
